var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn sidebarPersonalitation-btn rounded-0",on:{"click":_vm.toggleSidebar}},[_c('i',{staticClass:"fas fa-bars mr-2"}),_c('span',[_vm._v(_vm._s(_vm.t('menu.user_subscription.menu')))])])}
var staticRenderFns = []

export { render, staticRenderFns }